var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecuredocParagraphIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 4,
    fill: "#FFF0DF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5H15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11V18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10.5H21.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 16H22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 22H22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredocParagraphIcon);
export default __webpack_public_path__ + "static/media/securedoc-paragraph-icon.f174dc53dc7b9befc5fd51c6093617fb.svg";
export { ForwardRef as ReactComponent };